import { useSyncExternalStore } from "react";

/**
 * Hook pour détecter si le composant est monté côté client.
 * Utile pour éviter les erreurs d'hydratation lors de l'utilisation
 * de données qui ne sont disponibles que côté client (localStorage, etc.)
 *
 * @returns true après le premier rendu côté client, false pendant le SSR et le premier rendu
 *
 * @example
 * ```tsx
 * const isMounted = useHasMounted();
 * if (!isMounted) return null; // Évite l'erreur d'hydratation
 * // Afficher le contenu qui dépend du client
 * ```
 */
export function useHasMounted() {
  return useSyncExternalStore(_temp2, _temp3, _temp4);
}
function _temp4() {
  return false;
}
function _temp3() {
  return true;
}
function _temp2() {
  return _temp;
}
function _temp() {}